exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".order-btn{font-size:18px;color:#fff;background:linear-gradient(180deg,#fbba14,#ea757c);border-radius:2vw;width:175px;height:46px;border:none;transition:all .4s ease}.order-btn:hover{box-shadow:0 0 10px 0 rgba(0,0,0,.2745098039)}body[dir=rtl] .order-btn {\n  background: linear-gradient(-180deg,#fbba14,#ea757c);\n}\n", ""]);

// exports
